<template>
	<dialog-slot
			title="Eld name & access"
			@updateClose="onCloseDialog"
			@updateSave="onCloseDialog"
			width="400px"
			is-cancel-hide
			apply-text="Close"
	>
		<div class="eldList">
			<div class="eldList_item" :key="access_id" v-for="{ url, name, login, pass, access_id } in eldList">
				<div class="icon"><svg-sprite icon-id="icon-link" width="26" height="26"/></div>

				<div class="eldList_item-link">
					<a class="linkClassic" :href="url" target="_blank">{{ name }}</a>
				</div>

				<copied-btn
						:value="login"
						icon="user"
						:iconW="20"
						:iconH="20"
						copiedSuccess="Login copied"
				></copied-btn>
				<copied-btn
						:value="pass"
						icon="lock"
						:iconW="20"
						:iconH="20"
						copiedSuccess="Password copied"
				></copied-btn>
			</div>
		</div>
	</dialog-slot>
</template>
<script>
import CopiedBtn from "@/components/Safety/Logbooks/SafetyCalendar-list/CopiedBtn";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "EldPopup",
	components: { DialogSlot, CopiedBtn },
	props: {
		eldList: Array,
	},
	methods: {
		onCloseDialog() {
			this.$emit("updateCloseDialog");
		},
	},
};
</script>

<style scoped lang="scss">
.eldList {
  &_item {
    display: flex;
	  align-items: center;
	  gap: 4px;
	  .icon {
		  color: var(--base-green);
	  }
	  &-link {
		  flex-grow: 1;
		  a {
			  color: var(--base-orange);
		  }
	  }
  }
}
</style>
